export default `float e=4.,s;
  for(int j=0;++j<7;p=abs(p)-.9,e/=s=min(dot(p,p),.9),p/=s);
  return length(p.xz)/e;
}`